module.exports = __webpack_public_path__ + "static/media/security-check_4.1ba38dcd.png";